/*
 * 半屏弹窗组件
 * 用于满足需要半屏弹窗交互的场景
 * 调用方式: new HalfScreenDialog(html, buttons)
 * 后续规划：
 * 1. 高层API封装：封装常见HalfScreenDialog场景函数，快速调用
 * 2. 解决多个半屏弹窗组件同时存在时的冲突问题
 */

// let halfScreenDialog = null;
import Env from 'common/env.js';

let stopHideWhenMaskClick = false;
import wx from 'common/scripts/wx';
function HalfScreenDialog(html = '', buttons, bottomHtml = '') {
  return this.init(html, buttons, bottomHtml);
}
function stopBodyScroll(isStop) {
  if (Env.isiOS && Env.iOSVersion < 13) {
    wx.fixPage(isStop);
  } else {
    document.body.style.overflow = isStop ? 'hidden' : 'auto';
  }
}

function hide() {
  if (stopHideWhenMaskClick) {
    return;
  }
  let dialogDom = document.querySelector('.wg-half-screen-dialog');
  let maskDom = document.querySelector('.wg-half-screen-dialog__mask');
  let panelDom = document.querySelector('.wg-half-screen-dialog__wraper');

  // panelDom.style.bottom = '-100%';
  panelDom.style.transform = 'translate3d(0,100%,0)';
  maskDom.style.opacity = 0;

  setTimeout(function() {
    // dialogDom.style.bottom = '-100%'
    dialogDom.style.transform = 'translate3d(0,100%,0)';
    stopBodyScroll(false);
    setTimeout(() => {
      // 兼容先隐藏后显示的情况，此时实际上弹窗没有真的隐藏，则不抛出事件
      if (window && window.dispatchEvent && dialogDom.style.transform.indexOf('100%') > -1) {
        let event = new Event('__halfScreenDialogClose__');
        window.dispatchEvent(event);
      }
    }, 300);
    WXGAME && WXGAME.WxBridge.invoke('setGameTab', { isShowTab: 1 });
  }, 200);
}

HalfScreenDialog.prototype.stopMaskClick = function(boo = true) {
  stopHideWhenMaskClick = !!boo;
};
HalfScreenDialog.prototype.show = function(callback) {
  let self = this;
  setTimeout(function() {
    // self.dialogDom.style.bottom = 0;
    self.maskDom.style.opacity = 1;
    // self.panelDom.style.bottom = 0;
    self.dialogDom.style.transform = 'translate3d(0,0,0)';
    self.panelDom.style.transform = 'translate3d(0,0,0)';

    stopBodyScroll(true);

    callback && callback();
  }, 0);

  WXGAME && WXGAME.WxBridge.invoke('setGameTab', { isShowTab: 0 });
};

HalfScreenDialog.prototype.init = function(html, buttons, bottomHtml) {
  var self = this;
  this.insertStyle();
  this.insertDom(buttons, bottomHtml);
  this.insertData(html);
  if (!(Array.isArray(buttons) && buttons.length === 0)) {
    this.insertButton(buttons);
  }
  bottomHtml && this.insertBottom(bottomHtml);

  this.dialogDom = document.querySelector('.wg-half-screen-dialog');
  this.maskDom = document.querySelector('.wg-half-screen-dialog__mask');
  this.panelDom = document.querySelector('.wg-half-screen-dialog__wraper');
  this.bottomDom = document.querySelector('.wg-half-screen-dialog__bottom');

  this.bindEvent();

  return this;
};

HalfScreenDialog.prototype.insertStyle = function() {
  var dialogDom = document.getElementById('welfare-center-half_screen_dialog_style');
  if (!dialogDom) {
    var dom = document.createElement('style');
    dom.setAttribute('type', 'text/css');
    dom.setAttribute('id', 'welfare-center-half_screen_dialog_style');

    const style = `
.common-dialog-wraper {
    padding-left: 24PX;
}

.common-dialog-title {
    font-size: 15PX;
    font-family: PingFangSC-Medium, sans-serif;
    color: rgba(0, 0, 0);
    padding-top: 10PX;
    margin-bottom: 25PX;
}

.common-dialog-content {
    font-size: 17PX;
    font-family: PingFangSC-Medium, sans-serif;
    color: rgba(0, 0, 0);
    padding-bottom: 16PX;
    border-bottom: 0.5px solid rgba(0, 0, 0, 0.05);
}

.wg_dark_mode .common-dialog-title {
    color: rgba(255, 255, 255, 0.9) !important;
}

.wg_dark_mode .common-dialog-content {
    color: rgba(255, 255, 255, 0.3) !important;
}

.common-dialog-gift_list {
    max-height: 295PX;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
}

.common-dialog-gift {
    padding: 12px 0;
    border-bottom: 0.5px solid rgba(0, 0, 0, 0.05);
}

.common-dialog-gift .common-dialog-gift_title {
    font-size: 17PX;
    color: rgba(0, 0, 0, 0.9);
}

.common-dialog-gift .common-dialog-gift_content {
    font-size: 14PX;
    color: rgba(0, 0, 0, 0.3);
}

.wg_dark_mode .common-dialog-gift_title {
    color: rgba(255,255,255,0.8)!important;
}

.wg_dark_mode .common-dialog-gift_content {
    color: rgba(255,255,255,0.8)!important;
}

.common-dialog-checkbox_wraper {
    font-size: 14PX;
    color: rgba(0, 0, 0, 0.3);
    margin-bottom: 32PX;
    display: flex;
    justify-content: center;
    align-items: center;
}

.unknow-dialog-wraper {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 28PX;
}
.unknow-dialog-title {
    font-size: 17PX;
    font-family: PingFangSC-Medium, sans-serif;
    margin-bottom: 8PX;
}
.wg_dark_mode .unknow-dialog-title {
    color: rgba(255, 255, 255, 0.9) !important;
}
.unknow-dialog-content {
    font-size: 14PX;
    margin-bottom: 24PX;
    text-align: center;
}
.wg_dark_mode .unknow-dialog-content {
    color: rgba(255, 255, 255, 0.3) !important;
}

.wg-half-screen-dialog {
    position: fixed;
    left: 0;
    bottom: -100%;
    width: 100%;
    height: 100%;
    z-index: 100001;
    bottom: 0;
    transform: translate3d(0,100%,0);
}

.wg-half-screen-dialog__mask {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    background-color: rgba(0, 0, 0, 0.6);
    transition: opacity .1s linear;
}

.wg-half-screen-dialog__wraper {
    position: absolute;
    left: 0;
    bottom: -100%;
    width: 100%;
    min-height: 200PX;
    max-height: 75%;
    background: #ffffff;
    border-top-left-radius: 12PX;
    border-top-right-radius: 12PX;
    transition: transform .2s ease-in-out;
    color: rgba(0,0,0,0.9);
    overflow: hidden;
    bottom: 0;
    transform: translate3d(0,100%,0);
}

@media only screen and (device-width: 375PX) and (device-height: 812PX) and (-webkit-device-pixel-ratio: 3) {
    .wg-half-screen-dialog__main {
        padding-bottom: 68PX;
    }
    .wg-half-screen-dialog__bottom-has-button {
        padding-bottom: 66px!important;
    }
    .wg-half-screen-dialog__content-has-bottom {
        padding-bottom: 75px!important;
    }
}

@media only screen and (device-width: 414PX) and (device-height: 896PX) and (-webkit-device-pixel-ratio: 3) {
    .wg-half-screen-dialog__main {
        padding-bottom: 62PX;
    }
    .wg-half-screen-dialog__bottom-has-button {
        padding-bottom: 63px!important;
    }
    .wg-half-screen-dialog__content-has-bottom {
        padding-bottom: 75px!important;
    }
}

@media only screen and (device-width: 414PX) and (device-height: 896PX) and (-webkit-device-pixel-ratio: 2) {
    .wg-half-screen-dialog__main {
        padding-bottom: 62PX;
    }
    .wg-half-screen-dialog__bottom-has-button {
        padding-bottom: 63px!important;
    }
    .wg-half-screen-dialog__content-has-bottom {
        padding-bottom: 75px!important;
    }
} 

.wg-half-screen-dialog__wraper::-webkit-scrollbar {
    display: none;
}

.wg_dark_mode .wg-half-screen-dialog__wraper {
    background: #232323;
    color: rgba(255,255,255,0.8);
}

.wg-half-screen-dialog__content {
    flex-grow: 1;
    padding-top: 12PX;
}

.wg-half-screen-dialog__content::-webkit-scrollbar {
    display: none;
}

.wg-half-screen-dialog__content-has-bottom {
    padding-bottom: 104PX;
}

.wg-half-screen-dialog__bottom {
    width: 100%;
    display: flex;
    padding-top: 32PX;
    padding-bottom: 32PX;
    justify-content: center;
    margin: 0 auto;
    position: absolute;
    bottom: 0;
    background-color: #ffffff;
}

.wg-half-screen-dialog__bottom-none {
    display: none;
}

.wg_dark_mode .wg-half-screen-dialog__bottom {
    background-color: #232323;
}

.wg-half-screen-dialog__button {
    width: 120PX;
    height: 40PX;
    background: rgba(0, 0, 0, 0.05);
    color: #06ae56;
    border-radius: 4PX;
    font-family: PingFangSC-Medium;
    font-size: 17PX;
    letter-spacing: 1PX;
    text-align: center;
    line-height: 40PX;
    margin-right: 16PX;
}

.wg-half-screen-dialog__button-single-large {
    width: 180PX;
}

.wg-half-screen-dialog__button:last-child {
    margin-right: 0;
} 
.wg_dark_mode .wg-half-screen-dialog__button {
    background: rgba(255, 255, 255, 0.08);
    color: rgba(255, 255, 255, 0.8);
}


.wg-half-screen-dialog__button-danger {
    background-color: #d9534f;
    color: #FFFFFF;
}
.wg_dark_mode .wg-half-screen-dialog__button-danger {
    background-color: #d9534f;
    color: #FFFFFF;
}

.wg-half-screen-dialog__button-primary {
    background: #07C160;
    color: #FFFFFF;
}
.wg_dark_mode .wg-half-screen-dialog__button-primary {
    background: #07C160;
    color: #FFFFFF;
}
.wg-half-screen-dialog__button-primary-disabled {
    background: #04C160;
    opacity: 0.5;
    color: #FFFFFF;
}
.wg-half-screen-dialog__main {
    display: flex;
}
.wg-half-screen-dialog__main-item {
    display: flex;
    flex-direction: column;
    width: 100vw;
}

 .common-dialog-wraper {
    padding-left: 24PX;
}

.common-dialog-title {
    font-size: 15PX;
    font-family: PingFangSC-Medium, sans-serif;
    color: rgba(0, 0, 0);
    padding-top: 10PX;
    margin-bottom: 25PX;
}

.common-dialog-content {
    font-size: 17PX;
    font-family: PingFangSC-Medium, sans-serif;
    color: rgba(0, 0, 0);
    padding-bottom: 16PX;
    border-bottom: 0.5px solid rgba(0, 0, 0, 0.05);
}

.common-dialog-gift_list {
    max-height: 295PX;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
}

.common-dialog-gift {
    padding: 12px 0;
    border-bottom: 0.5px solid rgba(0, 0, 0, 0.05);
}

.wg_dark_mode .common-dialog-gift {
    border-bottom: 0.5px solid rgba(255, 255, 255, 0.05) !important;
}

.common-dialog-gift .common-dialog-gift_title {
    font-size: 17PX;
    color: rgba(0, 0, 0, 0.9);
}

.common-dialog-gift .common-dialog-gift_content {
    font-size: 14PX;
    color: rgba(0, 0, 0, 0.3);
}

.common-dialog-checkbox_wraper {
    font-size: 14PX;
    color: rgba(0, 0, 0, 0.3);
    margin-bottom: 32PX;
    display: flex;
    justify-content: center;
    align-items: center;
}

.common-dialog-checkbox_wraper .common-dialog-checkbox {
        height: 18PX;
        width: 18PX;
        display: inline-block;
        background-image: url('//res.wx.qq.com/wechatgame/product/cdn/welfare/nochecked_eb906919.png');
        background-size: contain;
        background-position: center;
        margin-right: 4PX;
}

.unknow-dialog-wraper {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 28PX;
}

.unknow-dialog-title {
    font-size: 17PX;
    font-family: PingFangSC-Medium, sans-serif;
    margin-bottom: 8PX;
}

.unknow-dialog-content {
    font-size: 14PX;
    margin-bottom: 24PX;
    text-align: center;
}

.unknow-dialog-image {
    height: 271PX;
    width: 186PX;
    background-image: url('//res.wx.qq.com/wechatgame/product/cdn/welfare/unknow-dialog-image_d5b17bf9.png');
    background-size: contain;
}

.receive-fail-dialog_title {
    font-size: 17PX;
    font-style: PingFangSC-Medium;
    text-align: center;
    padding-top: 28PX;
    color: rgba(0, 0, 0, 0.9);
}

.wg_dark_mode .receive-fail-dialog_title  {
    color: rgba(255, 255, 255, 0.8);
}

.receive-fail-dialog_content {
    margin-top: 8PX;
    font-size: 14PX;
    color: rgba(0, 0, 0, 0.5);
    text-align: center;
}

.wg_dark_mode .receive-fail-dialog_content {
    color: rgba(255, 255, 255, 0.5);
}

.receive-fail-dialog_gamestart {
    font-size: 14PX;
    color: #576b95;
}
`;

    dom.innerHTML = style;
    var head = document.getElementsByTagName('head')[0];
    head.appendChild(dom);
  }
};

HalfScreenDialog.prototype.insertDom = function(buttons, bottomHtml) {
  var dialogDom = document.getElementById('__welfare_basic_dialog_dom__');
  if (!dialogDom) {
    var dom = document.createElement('div');
    dom.setAttribute('id', '__welfare_basic_dialog_dom__');
    dom.classList.add(`wg-half-screen-dialog`);

    var div = [
      '<div class="wg-half-screen-dialog__mask"></div>',
      '<div class="wg-half-screen-dialog__wraper">',
      '<div class="wg-half-screen-dialog__main">',
      '<div class="wg-half-screen-dialog__main-item">',
      '<div class="wg-half-screen-dialog__content">',
      '</div>',
      '<div class="wg-half-screen-dialog__extra"></div>',
      '</div>',
      '</div>',
      '</div>'
    ];
    if (buttons || bottomHtml) {
      div = [
        '<div class="wg-half-screen-dialog__mask"></div>',
        '<div class="wg-half-screen-dialog__wraper">',
        '<div class="wg-half-screen-dialog__main">',
        '<div class="wg-half-screen-dialog__main-item">',
        '<div class="wg-half-screen-dialog__content wg-half-screen-dialog__content-has-bottom">',
        '</div>',
        '<div class="wg-half-screen-dialog__bottom"></div>',
        '<div class="wg-half-screen-dialog__extra"></div>',
        '</div>',
        '</div>',
        '</div>'
      ];
    }

    dom.innerHTML = div.join('');
    document.body.appendChild(dom);
  }
};

HalfScreenDialog.prototype.insertBottom = function(bottomHtml) {
  var dom = document.querySelector('.wg-half-screen-dialog__extra');
  dom && (dom.innerHTML += bottomHtml);
};

HalfScreenDialog.prototype.insertData = function(html) {
  try {
    var dom = document.querySelector('.wg-half-screen-dialog__content');
    if (dom && typeof dom.innerHTML === 'string') {
      if (typeof html === 'string') {
        dom && (dom.innerHTML += html);
      } else if (Array.isArray(html) && html.length > 0) {
        let contentHtml = '';

        html.forEach((item) => {
          contentHtml += item.html;
        });

        dom && (dom.innerHTML += contentHtml);
        // 依次绑定事件
        setTimeout(() => {
          this.bindItemEvent(html);
        }, 0);
      }
    }
  } catch (error) {}
};

HalfScreenDialog.prototype.changeData = function(html, buttons, animationType = 'rise', callback) {
  let self = this;
  // 避免多次重复调用
  let mainItemCount = document.querySelectorAll('.wg-half-screen-dialog__main-item');

  if (mainItemCount.length > 1) {
    return;
  }

  let dialogDom = document.querySelector('.wg-half-screen-dialog');
  let maskDom = document.querySelector('.wg-half-screen-dialog__mask');
  let panelDom = document.querySelector('.wg-half-screen-dialog__wraper');

  if (dialogDom && maskDom && panelDom) {
    if (animationType === 'rise') {
      // 先下降再升起
      // self.panelDom.style.bottom = '-100%';
      self.panelDom.style.transform = 'translate3d(0,100%,0)';
      setTimeout(function() {
        let contentDom = document.querySelector('.wg-half-screen-dialog__content'),
          bottomDom = document.querySelector('.wg-half-screen-dialog__bottom');
        contentDom && (contentDom.innerHTML = '');
        bottomDom && (bottomDom.innerHTML = '');
        self.insertData(html);
        self.insertButton(buttons);
        // self.panelDom.style.bottom = '0';
        self.show(callback);
      }, 350);
    } else if (animationType === 'slideRight') {
      // 向右滑动
      // 思路：将新的main加到旧的main左侧，main整体向右translateX一屏的距离
      // 后续优化：高度的渐变过渡
      if (Env.isiOS) {
        let mainDom = document.querySelector('.wg-half-screen-dialog__main');
        let oldMainItemDom = document.querySelector('.wg-half-screen-dialog__main-item');
        // 根据html和buttons获取新的Dom
        let newMainItemDom = document.createElement('div');
        newMainItemDom.setAttribute('class', 'wg-half-screen-dialog__main-item');
        let newContentDom = document.createElement('div');
        newContentDom.setAttribute('class', 'wg-half-screen-dialog__content');

        if (typeof html === 'string') {
          newContentDom && (newContentDom.innerHTML += html);
        } else if (Array.isArray(html) && html.length > 0) {
          let contentHtml = '';

          html.forEach((item) => {
            contentHtml += item.html;
          });

          newContentDom && (newContentDom.innerHTML += contentHtml);
        }
        let newButtonDom = document.createElement('div');
        newButtonDom.setAttribute('class', 'wg-half-screen-dialog__bottom');
        let isCustomButtons = Array.isArray(buttons);
        let newButtonDomHtml = [];
        if (isCustomButtons) {
          let buttonHtml = '';
          for (let i = 0; i < buttons.length; i++) {
            let buttonLabel = buttons[i].label || '',
              buttonType = buttons[i].type,
              buttonClassSuffix = 'default',
              buttonTypeClass = 'wg-half-screen-dialog__button-',
              buttonClass = buttons[i].class;

            if (buttonType && buttonType !== 'default') {
              buttonClassSuffix = buttonType;
            }
            buttonTypeClass += buttonClassSuffix;

            // 单按钮则使用大按钮
            if (buttons.length === 1) {
              buttonClass += ' wg-half-screen-dialog__button-single-large';
            }
            buttonHtml = `<div class="wg-half-screen-dialog__button ${buttonTypeClass} wg-half-screen-dialog__button_${i} ${buttonClass}">
                            ${buttonLabel}
                        </div>`;
            newButtonDomHtml.push(buttonHtml);
          }
        } else {
          newButtonDomHtml = [
            '<div class="wg-half-screen-dialog__button wg-half-screen-dialog__button-left">取消</div>',
            '<div class="wg-half-screen-dialog__button wg-half-screen-dialog__button-primary">确定</div>'
          ];
        }

        if (Array.isArray(newButtonDomHtml) && newButtonDomHtml.length > 0 && newContentDom) {
          newContentDom.classList.add('wg-half-screen-dialog__content-has-bottom');
          newButtonDom.classList.add('wg-half-screen-dialog__bottom-has-button');
          newButtonDom.classList.remove('wg-half-screen-dialog__bottom-none');
        } else {
          newContentDom.classList.remove('wg-half-screen-dialog__content-has-bottom');
          newButtonDom.classList.remove('wg-half-screen-dialog__bottom-has-button');
          newButtonDom.classList.add('wg-half-screen-dialog__bottom-none');
        }

        newButtonDom && (newButtonDom.innerHTML += newButtonDomHtml.join(''));

        if (isCustomButtons) {
          setTimeout(() => {
            for (let j = 0; j < buttons.length; j++) {
              // 绑定按钮回调
              let buttonClass = '.wg-half-screen-dialog__button_' + j;
              let buttonDom = document.querySelector(buttonClass);
              buttonDom && buttonDom.addEventListener('click', buttons[j].callback);
              if (buttons[j].closeDialog !== false) {
                buttonDom && buttonDom.addEventListener('click', hide);
              }
            }
          }, 0);
        } else {
          newButtonDom.addEventListener('click', hide);
        }
        newMainItemDom.appendChild(newContentDom);
        newMainItemDom.appendChild(newContentDom);
        newMainItemDom.appendChild(newButtonDom);

        mainDom.style.width = '200vw';
        mainDom.appendChild(newMainItemDom);
        mainDom.style.transform = 'translatex(0)';

        oldMainItemDom.style.opacity = 1;
        oldMainItemDom.style.transition = 'opacity .2s ease-in';
        newMainItemDom.style.opacity = 0;
        newMainItemDom.style.transition = 'opacity .2s ease-out';

        setTimeout(() => {
          oldMainItemDom.style.opacity = 0;
          newMainItemDom.style.opacity = 1;
          mainDom.style.transition = 'transform .2s ease';
          mainDom.style.transform = 'translatex(-50%)';
        }, 0);
        setTimeout(() => {
          mainDom.style.width = '100vw';
          mainDom.removeChild(oldMainItemDom);
          mainDom.style.transform = 'translatex(0)';
          mainDom.style.transition = '';
          if (Array.isArray(html) && html.length > 0) {
            // 依次绑定事件
            self.bindItemEvent(html);
          }
        }, 200);
      } else {
        let contentDom = document.querySelector('.wg-half-screen-dialog__content'),
          bottomDom = document.querySelector('.wg-half-screen-dialog__bottom');
        contentDom && (contentDom.innerHTML = '');
        bottomDom && (bottomDom.innerHTML = '');

        self.insertData(html);
        self.insertButton(buttons);
      }
    } else if (animationType === 'slideLeft') {
      // 向左滑动
      // 思路：将新的main加到旧的main左侧，main整体向左translateX一屏的距离
      // 后续优化：高度的渐变过渡
      if (Env.isiOS) {
        let mainDom = document.querySelector('.wg-half-screen-dialog__main');
        let oldMainItemDom = document.querySelector('.wg-half-screen-dialog__main-item');
        // 根据html和buttons获取新的Dom
        let newMainItemDom = document.createElement('div');
        newMainItemDom.setAttribute('class', 'wg-half-screen-dialog__main-item');
        let newContentDom = document.createElement('div');
        newContentDom.setAttribute('class', 'wg-half-screen-dialog__content');
        if (typeof html === 'string') {
          newContentDom && (newContentDom.innerHTML += html);
        } else if (Array.isArray(html) && html.length > 0) {
          let contentHtml = '';

          html.forEach((item) => {
            contentHtml += item.html;
          });

          newContentDom && (newContentDom.innerHTML += contentHtml);
        }
        let newButtonDom = document.createElement('div');
        newButtonDom.setAttribute('class', 'wg-half-screen-dialog__bottom');
        let isCustomButtons = Array.isArray(buttons);
        let newButtonDomHtml = [];
        if (isCustomButtons) {
          let buttonHtml = '';
          for (let i = 0; i < buttons.length; i++) {
            let buttonLabel = buttons[i].label || '',
              buttonType = buttons[i].type,
              buttonClassSuffix = 'default',
              buttonTypeClass = 'wg-half-screen-dialog__button-',
              buttonClass = buttons[i].class;

            if (buttonType && buttonType !== 'default') {
              buttonClassSuffix = buttonType;
            }
            buttonTypeClass += buttonClassSuffix;

            // 单按钮则使用大按钮
            if (buttons.length === 1) {
              buttonClass += ' wg-half-screen-dialog__button-single-large';
            }

            buttonHtml = `<div class="wg-half-screen-dialog__button ${buttonTypeClass} wg-half-screen-dialog__button_${i} ${buttonClass}">
                            ${buttonLabel}
                        </div>`;
            newButtonDomHtml.push(buttonHtml);
          }
        } else {
          newButtonDomHtml = [
            '<div class="wg-half-screen-dialog__button wg-half-screen-dialog__button-left">取消</div>',
            '<div class="wg-half-screen-dialog__button wg-half-screen-dialog__button-primary">确定</div>'
          ];
        }

        if (Array.isArray(newButtonDomHtml) && newButtonDomHtml.length > 0 && newContentDom) {
          newContentDom.classList.add('wg-half-screen-dialog__content-has-bottom');
          newButtonDom.classList.add('wg-half-screen-dialog__bottom-has-button');
          newButtonDom.classList.remove('wg-half-screen-dialog__bottom-none');
        } else {
          newContentDom.classList.remove('wg-half-screen-dialog__content-has-bottom');
          newButtonDom.classList.remove('wg-half-screen-dialog__bottom-has-button');
          newButtonDom.classList.add('wg-half-screen-dialog__bottom-none');
        }

        newButtonDom && (newButtonDom.innerHTML += newButtonDomHtml.join(''));

        if (isCustomButtons) {
          setTimeout(() => {
            for (let j = 0; j < buttons.length; j++) {
              // 绑定按钮回调
              let buttonClass = '.wg-half-screen-dialog__button_' + j;
              let buttonDom = document.querySelector(buttonClass);
              buttonDom && buttonDom.addEventListener('click', buttons[j].callback);
              if (buttons[j].closeDialog !== false) {
                buttonDom && buttonDom.addEventListener('click', hide);
              }
            }
          }, 0);
        } else {
          newButtonDom.addEventListener('click', hide);
        }
        newMainItemDom.appendChild(newContentDom);
        newMainItemDom.appendChild(newContentDom);
        newMainItemDom.appendChild(newButtonDom);

        mainDom.style.width = '200vw';
        mainDom.insertBefore(newMainItemDom, oldMainItemDom);
        mainDom.style.transform = 'translatex(-50%)';

        oldMainItemDom.style.opacity = 1;
        oldMainItemDom.style.transition = 'opacity .2s ease-in';
        newMainItemDom.style.opacity = 0;
        newMainItemDom.style.transition = 'opacity .2s ease-out';

        setTimeout(() => {
          oldMainItemDom.style.opacity = 0;
          newMainItemDom.style.opacity = 1;
          mainDom.style.transition = 'transform .2s ease-out';
          mainDom.style.transform = 'translatex(0)';
        }, 0);
        setTimeout(() => {
          mainDom.style.width = '100vw';
          mainDom.removeChild(oldMainItemDom);

          mainDom.style.transition = '';
          if (Array.isArray(html) && html.length > 0) {
            // 依次绑定事件
            self.bindItemEvent(html);
          }
        }, 200);
      } else {
        let contentDom = document.querySelector('.wg-half-screen-dialog__content'),
          bottomDom = document.querySelector('.wg-half-screen-dialog__bottom');
        contentDom && (contentDom.innerHTML = '');
        bottomDom && (bottomDom.innerHTML = '');

        self.insertData(html);
        self.insertButton(buttons);
      }
    }
  } else {
    self.init(html, buttons);
  }
};

HalfScreenDialog.prototype.changeButton = function(buttons) {
  let self = this;
  let dom = document.querySelector('.wg-half-screen-dialog__bottom');
  if (dom) {
    dom.innerHTML = '';
    self.insertButton(buttons);
  }
};

HalfScreenDialog.prototype.bindItemEvent = function(html) {
  if (Array.isArray(html) && html.length > 0) {
    html.forEach((item) => {
      let eventType = item.eventType || 'click';
      if (item.target && item.callback) {
        let dom = document.querySelector(item.target);
        dom && dom.addEventListener(eventType, item.callback);
      }
    });
  }
};

HalfScreenDialog.prototype.insertButton = function(buttons) {
  var self = this;

  var dom = document.querySelector('.wg-half-screen-dialog__bottom'),
    isCustomButtons = Array.isArray(buttons);

  var html = [];

  if (isCustomButtons) {
    let buttonHtml = '';
    for (var i = 0; i < buttons.length; i++) {
      var buttonLabel = buttons[i].label || '',
        buttonType = buttons[i].type,
        buttonClassSuffix = 'default',
        buttonTypeClass = 'wg-half-screen-dialog__button-',
        buttonClass = buttons[i].class;

      if (buttonType && buttonType !== 'default') {
        buttonClassSuffix = buttonType;
      }
      buttonTypeClass += buttonClassSuffix;
      // 单按钮则使用大按钮
      if (buttons.length === 1) {
        buttonClass += ' wg-half-screen-dialog__button-single-large';
      }

      buttonHtml = `<div class="wg-half-screen-dialog__button ${buttonTypeClass} wg-half-screen-dialog__button_${i} ${buttonClass}">
                ${buttonLabel}
            </div>`;
      html.push(buttonHtml);
    }
  } else {
    html = [
      '<div class="wg-half-screen-dialog__button wg-half-screen-dialog__button-left">取消</div>',
      '<div class="wg-half-screen-dialog__button wg-half-screen-dialog__button-primary">确定</div>'
    ];
  }

  let contentDom = document.querySelector('.wg-half-screen-dialog__content');

  if (Array.isArray(html) && html.length > 0 && contentDom) {
    contentDom.classList.add('wg-half-screen-dialog__content-has-bottom');
    dom && dom.classList.add('wg-half-screen-dialog__bottom-has-button');
    dom && dom.classList.remove('wg-half-screen-dialog__bottom-none');
  } else {
    contentDom.classList.remove('wg-half-screen-dialog__content-has-bottom');
    dom && dom.classList.remove('wg-half-screen-dialog__bottom-has-button');
    dom && dom.classList.add('wg-half-screen-dialog__bottom-none');
  }

  dom && (dom.innerHTML += html.join(''));

  if (isCustomButtons) {
    setTimeout(() => {
      for (var j = 0; j < buttons.length; j++) {
        // 绑定按钮回调
        var buttonClass = '.wg-half-screen-dialog__button_' + j;
        var buttonDom = document.querySelector(buttonClass);
        buttonDom && buttonDom.addEventListener('click', buttons[j].callback);
        if (buttons[j].closeDialog !== false) {
          buttonDom && buttonDom.addEventListener('click', hide);
        }
      }
    }, 0);
  } else {
    self.buttonDom && self.bottomDom.addEventListener('click', hide);
  }
};

HalfScreenDialog.prototype.bindEvent = function() {
  this.maskDom.addEventListener('touchend', function(e) {
    e.stopPropagation();
    e.preventDefault();
    let dom = document.querySelectorAll('.wg-half-screen-dialog__button');

    if (!(dom && dom.length > 0)) {
      hide();
    }
  });

  this.maskDom.addEventListener('touchmove', function(e) {
    e.stopPropagation();
    e.preventDefault();
  });
  // this.bottomDom.addEventListener('click', function (e) {
  //     var className = e.target && e.target.className || ''
  //     if (className.indexOf('left') > -1) {
  //         self.closeEvent()
  //     } else {
  //         // self.successCbk()
  //         self.closeEvent()
  //     }
  // })
};

HalfScreenDialog.prototype.destory = function() {
  var self = this;

  // self.panelDom.style.bottom = '-100%';
  self.panelDom.style.transform = 'translate3d(0,100%,0)';
  self.maskDom.style.opacity = 0;

  setTimeout(function() {
    // self.dialogDom.style.bottom = '-100%';
    self.dialogDom.style.transform = 'translate3d(0,100%,0)';
    self.dialogDom.parentNode.removeChild(self.dialogDom);
  }, 200);
};

HalfScreenDialog.prototype.hide = function() {
  let dialogDom = document.querySelector('.wg-half-screen-dialog');
  let maskDom = document.querySelector('.wg-half-screen-dialog__mask');
  let panelDom = document.querySelector('.wg-half-screen-dialog__wraper');

  panelDom.style.transform = 'translate3d(0,100%,0)';
  maskDom.style.opacity = 0;

  setTimeout(function() {
    dialogDom.style.transform = 'translate3d(0,100%,0)';
    stopBodyScroll(false);
    setTimeout(() => {
      // 兼容先隐藏后显示的情况，此时实际上弹窗没有真的隐藏，则不抛出事件
      if (window && window.dispatchEvent && dialogDom.style.transform.indexOf('100%') > -1) {
        let event = new Event('__halfScreenDialogClose__');
        window.dispatchEvent(event);
      }
    }, 300);
  }, 200);
};

const halfScreenDialog = new HalfScreenDialog('', []);
export default halfScreenDialog;
//module.exports = halfScreenDialog;
